import React, { Component, Fragment } from 'react';
import { toJS } from 'mobx';

import RoundEdit from '../../Sale/RoundSection/RoundEdit';
import { localizable } from '../../../components/Localization';

@localizable
class IncreaseStep2 extends Component {
  render() {
    var {
      store: { roundEditStore, acceptedOffers = [], offers = [] },
      t,
    } = this.props;

    const offersValues = offers
      .filter((o) => acceptedOffers.includes(o.buyerId))
      .map((o) => o.submittedValue);
    const highestOffer = Math.max(...toJS(offersValues), 0);

    return (
      <Fragment>
        <ul className="hint">
          <li>{t('Please define the next round.')}</li>
          <li>{t('Validity of offers set to the same value')}</li>
        </ul>

        <div className="control">
          <RoundEdit
            store={roundEditStore}
            allowChangeType={roundEditStore.isSimpleOffer}
            disallowedRounds={['simple_offer']}
            overrideStartPrice={highestOffer > 0 ? highestOffer : null}
          />
        </div>
      </Fragment>
    );
  }
}

export default IncreaseStep2;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Increase/Step2.jsx